/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ObjectResponseDto } from '../models/ObjectResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AssessmentService {
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerMyProfile(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/profile',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerRecalcNorms(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assessment/norms/recalc',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerGetDescription({
        test,
        aspect,
        gradation,
        value,
    }: {
        test: string,
        aspect: string,
        gradation: string,
        value: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/description',
            query: {
                'test': test,
                'aspect': aspect,
                'gradation': gradation,
                'value': value,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerAvailableDescriptions(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/descriptions/available',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerAllDescriptions(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/descriptions/all',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerBigFiveTypes(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/bigfive/types',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerBigFiveRoles(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/bigfive/roles',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerBigFiveByCode({
        code,
    }: {
        code: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/bigfive/type/{code}',
            path: {
                'code': code,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerBigFiveDerive({
        o,
        c,
        e,
        a,
        n,
    }: {
        o: string,
        c: string,
        e: string,
        a: string,
        n: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/bigfive/derive',
            query: {
                'o': o,
                'c': c,
                'e': e,
                'a': a,
                'n': n,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerPsytypeAll(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/psytype/types',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerPsytypeCategories(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/psytype/categories',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerPsytypeByCode({
        code,
    }: {
        code: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/psytype/type/{code}',
            path: {
                'code': code,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerPsytypeFromBigFive({
        o,
        c,
        e,
        a,
        n,
    }: {
        o: string,
        c: string,
        e: string,
        a: string,
        n: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/psytype/from-bigfive',
            query: {
                'o': o,
                'c': c,
                'e': e,
                'a': a,
                'n': n,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static assessmentControllerMyFullProfile(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/my-profile',
        });
    }
}
